import { AvenAdvisorLeadAccountInfoPayload, AvenAdvisorAddressPayload } from 'aven_types'

export { Badge } from 'aven_types'
export type { PrefillInformation, PrefillAddressData, AvenAdvisorAddressPayload, NeighborhoodCrimeData, CrimeReport, BadgeMetadata, StreakResponse } from 'aven_types'

// currently do not support changing ownership status, just address
export type AvenAdvisorLeadUpdateAddressField = keyof Omit<AvenAdvisorAddressPayload, 'homeOwnershipStatus'>

export type AvenAdvisorLeadUpdatedField = keyof Pick<AvenAdvisorLeadAccountInfoPayload, 'firstName' | 'lastName' | 'email'> & AvenAdvisorLeadUpdateAddressField

export const DEFAULT_LIMIT_ON_CRIME_REPORTS = 20
